{
  "financingNoAccessWarning": "Du har ikke de nødvendige rettighetene. I deres klynge kan følgende personer se utbetalingsanmoding:",
  "sendPaymentRequestLink": "Send inn utbetalingsanmodning"
}
